import { createI18n } from "vue-i18n";
import { setLanguage } from "@/utils/storage";
import userService from "@/api/services/userService";
import { useUserStore } from "@/store/user";
import { getTld } from "@/utils/urlHelper.ts";

async function loadLocaleMessages(lang: string): Promise<Record<string, unknown>> {
  if (lang === "en") {
    return {};
  }

  if (getTld() === "net") {
    return {};
  }

  if (lang === "de") {
    const m = await import("./locales/de.json");
    return (m.default || m) as Record<string, unknown>;
  }

  if (lang === "fr") {
    const m = await import("./locales/fr.json");
    return (m.default || m) as Record<string, unknown>;
  }

  return {};
}

const i18n = createI18n({
  legacy: false,
  missingWarn: false,
  fallbackWarn: false,
  warnHtmlMessage: false,
  locale: "en",
  messages: {},
});

export default i18n;

export const changeLanguage = async (neededLang?: "en" | "de" | "fr") => {
  const locale = i18n.global.locale;
  const lang = neededLang ? neededLang : locale.value === "de" ? "en" : "de";

  if (!(i18n.global.messages.value as Record<string, unknown>)[lang]) {
    const messageData = await loadLocaleMessages(lang);
    i18n.global.setLocaleMessage(lang, messageData);
  }

  document.body.classList.remove("lang_en", "lang_de");
  document.body.classList.add(`lang_${lang}`);

  if (locale.value === lang) {
    return;
  }

  const userStore = useUserStore();

  if (userStore.getProfile) {
    userService.switchLang(lang);
  }

  locale.value = lang;
  setLanguage(lang);
};
